
<div class="container-fluid">

    <app-header ></app-header>
      
    <div class="row mt-3 d-flex justify-content-center signup-card">
        <div class="col-lg-3 col-xs-12 col-sm-12 col-md-12 col-md-mid-lg-4 ">
            <div class="text-center box-white">  
             
                <div class=" white-bg pt-0">
                    <h6 class="text-center ft-size-24 pb-2 pt-4"><b> Scan & pay your    </b> <br> <b> first instalment </b></h6> 
                   
                     
                    <qr-code value="{{qrcode}}" [size]=250></qr-code>  
                    
                    <!-- <img src="assets/images/orderCode.jpg" alt="Logo" width="100%">   -->

                    <h4 class="pt-4 text-center "><span style="font-size: 2rem;  ">Rs </span> <span style="font-size: 2.5rem; font-weight: bold;  " class="number-font word-braker">  {{ firstval }}.</span><span style="font-size: 2rem;   " class="number-font">{{ secondval }} </span> </h4>
                    <p class="text-center due-now-ui "> DUE NOW </p>
 
                    <div class="row order-value ml-1 mr-1">
                        <div class="col-6"> 
                            <p class="mb-2 ft-size-16  " > Rs <span class="number-font ft-size-25 word-braker order-sub-val">{{ firstval }}</span>.<span class="number-font">{{secondval}}</span></p>
                            <p class="due-now-ui ft-size-12 mb-0">DUE IN 30 DAYS</p>
                        </div>
                        <div class="col-6">
                            <p class="mb-2 ft-size-16 "  >  Rs  <span class="number-font ft-size-25 word-braker order-sub-val">{{ firstval }}</span>.<span class="number-font">{{secondval}}</span></p>
                            <p class="due-now-ui ft-size-12  mb-0">DUE IN 60 DAYS</p>
                        </div> 
                    </div>
                    <div class="row order-value-total ml-1 mr-1 mb-4">
                        <div class="col-5">
                            <p class="text-left mb-0  ">Your order <br> total value is</p> 
                        </div>
                        <div class="col-7 pl-0 pr-0">
                            <p class="text-right mb-0 line-h-30"> Rs <b class="ft-size-25 number-font font-weight-normal word-braker"  >{{twodecimal(productValue) }}</b> </p> 
                        </div> 
                    </div>


                    <div class="row order-value-total-2 pt-4 pb-4 ml-1 mr-1"> 
                        <div class="col-12 pl-0 pr-0 ">
                            <p class="text-center "> <img src="assets/images/loading-buffering.gif" width="40px"> </p> 
                            <a class="btn btn-primary cancel-c form-control no-border-radius mt-4 "  (click)="backtocalcel()"> CANCEL </a>
                        </div> 
                    </div>


                    <p class="pt-4 pb-4 text-center min-width-cen"> You've initiated the payment request. The customer has 24 hours to make the payment. You can check the status of this order in the orders page.</p>

                    <button class="btn btn-secondary form-control back-to-cas no-border-radius" (click)="backtohome()"> <b> BACK TO CASHIER PORTAL </b></button>
                </div> 
                
            </div>
             
        </div>
        <div class="col-lg-9   col-md-mid-lg-8"> 
            &nbsp;
        </div> 
    </div>
 
  
</div>

<div class="foter-mr-pd-fix">
    <app-footer></app-footer>
</div>